export default "3cdfe3af73f97a00.svg"